import { COLORS } from '@repo/design-system/index'
import { QIcon_outlink } from '@repo/icons/index'
import { Fragment } from 'react'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { n_landing } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import links from '../../../../../modules/links'
import urls from '../../../../../modules/urls'
import { ICONS } from '../useLandingNav'
import MainNavDropdown from './MainNavDropdown'

const products = (router) =>
  [
    {
      category: n_landing.gnb_menu_1.desc_1,
      items: [
        {
          key: 'lesson',
          icon: ICONS.student,
          title: n_landing.footer_title_1.list_1,
          description: n_landing.gnb_menu_1.sub_menu_1_desc,
          onClick: () => router.push(urls.student.adv.index(links.framer.advPath['1on1'].index)),
        },
        {
          key: 'aiTutor',
          icon: ICONS.aiTutor,
          title: n_landing.sub_menu_AItutor.title,
          description: n_landing.gnb_menu_1.sub_menu_1_desc,
          onClick: () => router.push(urls.student.adv.index(links.framer.advPath.aiTutor.index)),
        },
      ],
    },
    {
      category: n_landing.gnb_menu_1.desc_2,
      items: [
        {
          key: 'business',
          icon: ICONS.business,
          title: n_landing.sub_menu_b2b.title,
          description: n_landing.gnb_menu_1.sub_menu_3_desc,
          onClick: () => router.push(urls.b2b.index),
        },
      ],
    },
    {
      category: n_landing.gnb_menu_1.desc_3,
      items: [
        {
          key: 'teens',
          icon: ICONS.teens,
          title: n_landing.gnb_menu_1.sub_menu_4,
          description: n_landing.gnb_menu_1.sub_menu_4_desc,
          isExternal: true,
          onClick: () => window.open(links.teens.index, '_blank'),
        },
      ],
    },
  ] as const

const ProductNavLinks = () => {
  const router = useAppRouter()
  const { t, isLocaleKO } = useTranslation()

  return (
    <MainNavDropdown navTitle={t(n_landing.gnb_menu_1.list)}>
      {(onClose) => (
        <div className="sm:p-32 pt-12 w-full sm:w-[340px] flex flex-col gap-y-24">
          <div className="Body1-16Bd text-gray-800 sm:block hidden">{t(n_landing.gnb_menu_1.sub_title)}</div>
          <div className="flex flex-col gap-y-16">
            {products(router).map((product, index) => (
              <Fragment key={index}>
                <div className="flex sm:flex-row flex-col gap-y-10 gap-x-16 justify-between">
                  <div className={`Caption-12Md text-gray-500 ${!isLocaleKO && 'w-[48px]'}`}>{t(product.category)}</div>
                  <ul className="flex flex-col gap-y-16 flex-1">
                    {product.items.map((item, itemIndex) => (
                      <button
                        key={itemIndex}
                        className="p-4 flex gap-x-16 hover:bg-purple-50 active:opacity-50 rounded-lg flex-1 group"
                        onClick={(e) => {
                          e.stopPropagation()
                          item.onClick && item.onClick(router)
                          onClose()
                        }}
                      >
                        <img src={item.icon} alt={item.key} height={40} width={40} />
                        <div className="flex justify-between flex-1">
                          <div className="flex flex-col items-start text-start">
                            <span className="Body2-14Bd text-gray-600 group-hover:text-purple-600">
                              {t(item.title)}
                            </span>
                            <span className="Caption-12Md text-gray-500">{t(item.description)}</span>
                          </div>
                          {item.isExternal && <QIcon_outlink width={20} height={20} color={COLORS.GRAY300} />}
                        </div>
                      </button>
                    ))}
                  </ul>
                </div>
                {index < products.length - 1 && <div className="h-1 border-gray-50 rounded-lg" />}
              </Fragment>
            ))}
          </div>
        </div>
      )}
    </MainNavDropdown>
  )
}

export default ProductNavLinks
